<div class="close-button">
  <button class="clear-transparent" mat-dialog-close="">
    <span class="icon-close"></span>
  </button>
</div>
<mat-dialog-content class="new-app-dialog">
  <img src="/assets/images/others/new-app.png" />
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container>
    <a
      [href]="KSP_PERTIWI_URL"
      target="_blank"
      rel="noopener noreferrer"
      style="width: 100%"
    >
      <button cdkFocusInitial mat-button class="primary-button big-button mb-2">
        {{ "pages.landing.new-app-popup-button" | translate }}
      </button>
    </a>
  </ng-container>
</mat-dialog-actions>
